






import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import CKEditor from '@ckeditor/ckeditor5-vue';

@Component({
  components: {
    ClassicEditor,
    ckeditor: CKEditor.component
  }
})
export default class RichTextEditor extends Vue {
  editorText: string = '';

  @Prop() value!: string;
  @Prop({default: ''}) label?: string;

  @Emit('input')
  private emitUpdate(value: string) {
    return value;
  }

  @Watch('editorText')
  private updateValue(value: string) {
    return this.emitUpdate(value);
  }

  @Watch('value')
  private updateRichText(value: string) {
    return this.editorText = value;
  }

  mounted() {
    return this.editorText = this.value;
  }

  get editorConfig() {
    return {};
  }

  get editor() {
    return ClassicEditor;
  }
}
